exports.initialState = {
  empresa: "",
  updateComponent: true,
  carregar_estoque: false,

  valor_venda_tempo_real_venda: '0,00',
  valor_venda_tempo_real_meta: '0,00',
  valor_venda_tempo_real_margem: '0,00',
  valor_venda_tempo_real_meta_atingida: '0,00',
  valor_venda_tempo_real_perc_meta: 0,
  valor_venda_mes_venda: '0,00',
  valor_venda_mes_meta: '0,00',
  valor_venda_mes_margem: '0,00',
  valor_venda_mes_meta_atingida: '0,00',
  valor_venda_mes_perc_meta: '0,00',

  valor_ticket_medio_dia_ped: '0,00',
  valor_ticket_medio_dia_cli: '0,00',
  valor_ticket_medio_mes_ped: '0,00',
  valor_ticket_medio_mes_cli: '0,00',

  valor_a_pagar_dia_valor: '0,00',
  valor_a_pagar_dia_qtde: '0',
  valor_pagas_dia_valor: '0,00',
  valor_pagas_dia_qtde: '0',

  valor_a_pagar_mes_valor: '0,00',
  valor_a_pagar_mes_qtde: '0',
  valor_pagas_mes_valor: '0,00',
  valor_pagas_mes_qtde: '0',

  valor_a_receber_dia_valor: '0,00',
  valor_a_receber_dia_qtde: '0',
  valor_recebidas_dia_valor: '0,00',
  valor_recebidas_dia_qtde: '0',

  valor_a_receber_mes_valor: '0,00',
  valor_a_receber_mes_qtde: '0',
  valor_recebidas_mes_valor: '0,00',
  vr_total_estoque_geral: '0,00',
  vr_total_estoque_venda_futura: '0,00',
  vr_total_estoque_liquido: '0,00',
  valor_recebidas_mes_qtde: '0',

  ranking_grupo_produto_diario: [],
  ranking_grupo_produto_mensal: [],

  ranking_vendedor_diario: [],
  ranking_vendedor_mensal: [],

  ranking_cliente_diario: [],
  ranking_cliente_mensal: [],

  ranking_produto_diario: [],
  ranking_produto_mensal: [],

  ranking_venda_diario: [],
};



// WEBPACK FOOTER //
// ./src/utils/constants_initial_state.js